import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "components/sales/downloadDocView/documentView";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";

const ActiveInactive = ({
  match,
  getoffRoleEmployeesData,
  getEmployeesListing = [],
  getDataForDropdown,
  getDropdownDatas = [],
  updateStatusOffroleEmployee,
  statusUpdationByBusinessHead = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState({
    date_of_joining: "",
    date_of_exit: "",
    reason_for_exit: "",
    status: "",
    other_exit_reason: "",
  });
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getDataForDropdown();
      await getoffRoleEmployeesData(
        1,
        [],
        match?.params?.user_id,
        null,
        "USER"
      );
      setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (
      getEmployeesListing?.response?.data?.data &&
      getEmployeesListing?.response?.data?.data.length > 0
    ) {
      const details = getEmployeesListing.response.data.data[0];
      setData({
        department_id: details?.department_id || "",
        reason_for_exit: details?.reason_for_exit || "",
        date_of_joining: details?.date_of_joining || "",
        city_id: details?.city_id || "",
        employee_type: details?.employee_type || "",
        role_id: details?.role_id || "",
        action_remark: "",
        user_id: details?.user_id,
      });
    }
  }, [getEmployeesListing]);

  const today = new Date();
  const minJoiningDate = null;
  const maxJoiningDate = new Date(today);
  const minExitDate = new Date(today);
  minExitDate.setDate(today.getDate() - 30);
  const maxExitDate = new Date(today);

  const handleSuccessModalHide = () => {
    setIsSuccessModal(false);
  };

  const handleActive = async () => {
    formData["id"] = match?.params?.user_id;
    formData["status"] = 3;
    formData["update"] = true;
    setIsLoading(true);
    const res = await updateStatusOffroleEmployee(formData);
    if (res?.status == 200) {
      setMessage(res?.message);
      setIsSuccessModal(true);
    } else {
      toast.error(res?.message);
    }
    setIsLoading(false);
  };

  const handleInActive = async () => {
    formData["id"] = match?.params?.user_id;
    formData["status"] = 4;
    formData["update"] = true;
    setIsLoading(true);
    const res = await updateStatusOffroleEmployee(formData);
    if (res?.status == 200) {
      setMessage(res?.message);
      setIsSuccessModal(true);
    } else {
      toast.error(res?.message);
    }
    setIsLoading(false);
  };

  const storedData = localStorage.getItem("profileDetails");
  const parsed = JSON.parse(storedData);
  const teamName = parsed[0].team_name;

  return (
    <Layout title={"Employee Details"} isGoback isLoading={isLoading}>
      {getEmployeesListing?.response?.data?.data?.length > 0 ? (
        getEmployeesListing.response.data.data.map((details, index) =>
          details?.id ? (
            <div key={index} className="panel-card">
              <div
                className="panel-heading"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{localization.employeeDetails}</span>

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: details?.status_name === "Active" ? "green" : "red",
                    fontWeight: 600,
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        details?.status_name === "Active" ? "green" : "red",
                      display: "inline-block",
                    }}
                  ></span>

                  {details?.status_name ?? localization.na}
                </span>
              </div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.fullName}
                    data={details?.employee_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.phoneNumber}
                    data={details?.phone_number ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.department}
                    data={details?.department_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.team}
                    data={teamName ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.designation}
                    data={details?.designation_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.employeeType}
                    data={details?.employee_type_name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.location}
                    data={details?.city_name ?? localization.na}
                  />
                  {/* {(details?.status == 3 || details?.status == 4) && (
                    <DivLayout heading={localization.employeeStatus} data={details?.status_name ?? localization.na} />
                )} */}
                  {details?.status == 3 && (
                    <DivLayout
                      heading={localization.dateOfJoining}
                      data={details?.date_of_joining ?? localization.na}
                    />
                  )}
                  {details?.status == 4 && (
                    <>
                      <DivLayout
                        heading={localization.lastWorkingDate}
                        data={details?.last_working_date ?? localization.na}
                      />
                      <DivLayout
                        heading={localization.exitReason}
                        data={details?.exit_reason_name ?? localization.na}
                      />
                    </>
                  )}
                </div>

                {details?.status == 3 && (
                  <div className="row mt-3">
                    <div className="col-md-4">
                      <DatePicker
                        label={localization.dateOfExit}
                        required={true}
                        minimumDate={minExitDate}
                        maxDate={maxExitDate}
                        defaultValue={formData.date_of_exit}
                        value={details?.date_of_exit}
                        handleChange={(val) => {
                          setData({
                            ...formData,
                            date_of_exit: val,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <DropDownInput
                        data={getDropdownDatas?.response?.data?.exit_reasons}
                        label={localization.exitReason}
                        required
                        getIdValue={(val) => {
                          if (formData.reason_for_exit !== val.id) {
                            setData({ ...formData, reason_for_exit: val.id });
                          }
                        }}
                        errorMsg={localization.required}
                        isStarRequired={true}
                        getValueById={formData.reason_for_exit}
                      />
                    </div>
                    {parseInt(formData.reason_for_exit) === 7 && (
                      <div className="col-md-4">
                        <ConstantInput
                          label={localization.reason}
                          errorMsg={localization.required}
                          maxLength={10}
                          type="text"
                          required
                          isStarRequired={true}
                          handleChange={(value) => {
                            setData({ ...formData, other_exit_reason: value });
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {details?.status == 4 && (
                  <div className="row mt-3">
                    <div className="col-md-4">
                      <DatePicker
                        label={localization.dateOfJoining}
                        required={true}
                        minimumDate={minJoiningDate}
                        maxDate={maxJoiningDate}
                        defaultValue={formData.date_of_joining}
                        value={details?.date_of_joining}
                        handleChange={(val) => {
                          setData({
                            ...formData,
                            date_of_joining: val,
                          });
                        }}
                      />
                    </div>
                  </div>
                )}

                {details?.status == 3 && (
                  <div className="col-md-12 d-flex mb-4 mt-3">
                    <Button
                      className="btn btn-sm btn-success"
                      onClick={handleInActive}
                    >
                      Off-Board
                    </Button>
                  </div>
                )}
                {details?.status == 4 && (
                  <div className="col-md-12 d-flex mb-4 mt-3">
                    <Button
                      className="btn btn-sm btn-success"
                      onClick={handleActive}
                    >
                      On-Board
                    </Button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div key={index} className="panel-card">
              <div
                className="panel-heading"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{localization.employeeDetails}</span>

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color:
                      details?.user_status_name === "Active" ? "green" : "red",
                    fontWeight: 600,
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        details?.user_status_name === "Active"
                          ? "green"
                          : "red",
                      display: "inline-block",
                    }}
                  ></span>

                  {details?.user_status_name ?? localization.na}
                </span>
              </div>

              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.fullName}
                    data={details?.name ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.email}
                    data={details?.email ?? localization.na}
                  />
                  <DivLayout
                    heading={localization.mobileNumber}
                    data={details?.mobile_number ?? localization.na}
                  />
                </div>

                <hr />
              </div>
            </div>
          )
        )
      ) : (
        <div>
          <img src={Images?.NoData} alt="" width="100%" />
        </div>
      )}

      <ModalPop
        title={localization.conf}
        show={isSuccessModal}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{message}</h5>
          <Link
            to={`${baseUrl}/active-reactive-list`}
            className="btn btn-primary mb-4"
          >
            {"Go back to list"} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ActiveInactive;
